import axios from "axios";
/** 
 * 本日熱門
 * Api文件: 無
 * 國內:id=28
 * 國外:id=29
 */
export const getHotArticle = (dataId) => {
  return axios({
    method: "get",
    url: "https://www.pixnet.net/mainpage/api/blog/articles",
    params: {
      sort: "hot",
      type: "category",
      pre_page: 10,
      id: dataId,
      ver: 2
    },
    headers: {
      "Content-type": "application/x-www-form-urlencoded;charset=utf-8"
    }
  });
}
/** 
 * 收藏物件
 * http://pixmainpage.doc.pixnet.work/new/collection/create.html
 */
export function postCollection(dataObjectId) {
  let tmpPostData = {
    object_id: dataObjectId,
    type: "article"
  };
  return axios({
    method: "post",
    url: "https://www.pixnet.net/api/v1/member/collections",
    data: JSON.stringify(tmpPostData),
    headers: {
      "Authorization": "Bearer " + window.pix.member_token,
      "Content-type": "application/json"
    }
  });
}
/** 
 * 刪除收藏物件
 * http://pixmainpage.doc.pixnet.work/new/collection/delete.html
 */
export function deleteCollection(dataObjectId) {
  let tmpPostData = {
    object_ids: [dataObjectId],
    type: "article"
  };
  return axios({
    method: "delete",
    url: "https://www.pixnet.net/api/v1/member/collections",
    data: JSON.stringify(tmpPostData),
    headers: {
      "Authorization": "Bearer " + window.pix.member_token,
      "Content-type": "application/json"
    }
  });
}
/** 
 * 按讚
 * Api文件 http://showdoc.cmh.com.tw:4999/web/#/8/122
 */
export function setPush(dataCommentId) {
  const paramsData = {
    "comment_id": dataCommentId,
    "push_count": 1,
    "service": "blog-article"
  };
  return axios({
    method: "post",
    url: "https://www.pixnet.net/mainpage/api/pushes",
    data: JSON.stringify(paramsData),
    headers: {
      "Authorization": "Bearer " + window.pix.member_token,
      "Content-type": "application/json"
    }
  });
}
/** 
 * 取消讚
 * Api文件 http://showdoc.cmh.com.tw:4999/web/#/8/126
 */
export function deletePush(dataCommentId) {
  const paramsData = {
    "service": "blog-article",
    "comment_id": dataCommentId
  };
  return axios({
    method: "delete",
    url: "https://www.pixnet.net/mainpage/api/pushes",
    data: JSON.stringify(paramsData),
    headers: {
      "Authorization": "Bearer " + window.pix.member_token,
      "Content-type": "application/json"
    }
  });
}